import React from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { FaTrashAlt } from "react-icons/fa";
import { GrTest } from "react-icons/gr";
import styles from '../clinicLabProfile/clinicLabProfile.module.scss';

const ViewAllTest = ({ viewAllclinicTestProfile, setViewAllclinicTestProfile, clinicLestProfileDetails, handleConfirmDelete, handleDeleteTest }) => {

    return (
        <>
            <Modal
                centered
                show={viewAllclinicTestProfile}
                onHide={() => setViewAllclinicTestProfile(false)}
                size={"xl"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">
                        All Test Masters in {clinicLestProfileDetails?.clinicId?.userId?.name}
                    </h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setViewAllclinicTestProfile(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <Row>
                        {clinicLestProfileDetails?.tests && clinicLestProfileDetails?.tests?.map((item, index) => (
                            <Col xl={4} key={index}>
                                <div className={styles.testCard}>
                                    <div className={styles.testCardInner}>
                                        <GrTest />
                                        <p className={styles.testName}>{item?.testName}</p>
                                    </div>
                                    <FaTrashAlt className={styles.trashIcon} onClick={() => handleDeleteTest(item?._id)} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Modal>
        </>
    );
};

export default ViewAllTest;